<template>
  <div class="bg-img">
    <div class="visualImage" v-show="isLang === 0"></div>
    <div class="visualImage_en" v-show="isLang === 1"></div>
    <div class="visualImage_jp" v-show="isLang === 2"></div>
  </div>
</template>

<script>
export default {
  name: 'MainVisualImage',
  data() {
    return {
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
};
</script>

<style scoped lang="scss">
.visualImage {
  content: url('~@/assets/images/Annex/annex-visual-01.jpg');
  margin: 0;
  width: 100%;
}

.visualImage_en {
  content: url('~@/assets/images/Annex/annex-visual-01_en.jpg');
  margin: 0;
  width: 100%;
}

.visualImage_jp {
  content: url('~@/assets/images/Annex/annex-visual-01_jp.jpg');
  margin: 0;
  width: 100%;
}

@media (max-width: 992px) {
  .visualImage {
    content: url('~@/assets/images/Annex/annex-visual-01_m.jpg');
    margin: 0;
    width: 100%;
  }

  .visualImage_en {
    content: url('~@/assets/images/Annex/annex-visual-01_en_m.jpg');
    margin: 0;
    width: 100%;
  }

  .visualImage_jp {
    content: url('~@/assets/images/Annex/annex-visual-01_jp_m.jpg');
    margin: 0;
    width: 100%;
  }
}
</style>
